
export const handleQuizInitialized=(index: number, quizLength: number, prevQid: string, presentQid: string)=>{
    const detail = `${index}_${quizLength}_${prevQid}_${presentQid}`
    customEventHandler("quiz_initialized", detail)
}

export const handleQuizProgress=(index: number, quizLength: number, prevQid: string, presentQid: string)=>{
    const detail = `${index}_${quizLength}_${prevQid}_${presentQid}`
    customEventHandler("quiz_progress", detail)
}

export const handleQuizLoad = (quizLoad: string)=>{
    customEventHandler("react_quiz_loaded", quizLoad)
}


const customEventHandler = (eventName: string, detail: string) => {
    const customEvent = new CustomEvent(eventName, {detail})
    window.dispatchEvent(customEvent)
}